import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

const PageNotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const checkToken = window.sessionStorage.getItem("q2p_token");

const notificationRoute = sessionStorage.getItem(
  "notification_click_route",
);

const notificationClickPending =
  sessionStorage.getItem("notification_click_pending") === "true";

const redirectedFromNotificationRoute = Boolean(notificationRoute);

  const goToHomePage = () => {
    if (checkToken) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };

  const notificationClick =
  location.state?.fromNotification === true ||
  Boolean(location.state?.notificationRoute) ||
  redirectedFromNotificationRoute ||
  notificationClickPending ||
  localStorage.getItem("notification_click") === "notification_click" ||
  new URLSearchParams(window.location.search).get("notification_click") ===
    "true";

  useEffect(() => {
  return () => {
    localStorage.removeItem("notification_click");
    sessionStorage.removeItem("notification_click_route");
    sessionStorage.removeItem("notification_click_pending");
  };
}, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen overflow-hidden px-padding-md">
      <div className="flex flex-col items-center justify-center max-w-graphic-width-lg">
        <img
          src={ICONS?.PAGE_NOT_FOUND}
          alt="Centered"
          className="w-graphic-width-lg"
        />

        {notificationClick ? (
          <>
            <div className="pt-padding-sm text-center">
              <div className="text-font-md Qsm:text-font-lg font-semibold text-text-primary">
                Notification unavailable
              </div>
              <div className="flex w-full gap-gap-sm pt-padding-sm justify-center">
                <PrimaryButton
                  btnText="Home dashboard"
                  enabledBgColor="var(--primary-act)"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => {
                    goToHomePage();
                  }}
                  hoverOption="white"
                />
              </div>
            </div>
          </>
        ) : (
          <div className="text-center">
            <h4 className="text-4xl text-text-primary mb-margin-sm">
              Page not found
            </h4>
            <p className="text-lg text-text-primary">
              Sorry, the page you are looking for does not exist.
            </p>
            <div className="pt-padding-md mt-margin-lg">
              <button
                className="bg-text-primary text-black p-padding-md rounded-4xl font-semibold hover:bg-[#DBDBDB]"
                onClick={goToHomePage}
              >
                GO TO {checkToken ? "HOME DASHBOARD" : "HOME"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageNotFound;
